'use client'

import Link from 'next/link'
import { useParams } from 'next/navigation'
import Icon from '@/components/v2/ui/icon'
import { useTexts } from '@/contexts/LanguageContext'
import { TRUST_CENTER_SECTIONS, trustCenterPath } from '../../utils'
import type { IControlDomain } from '../controlDomains'

export default function DomainCard({ domain }: { domain: IControlDomain }) {
  const { CONTROLS } = useTexts().PUBLIC_TRUST_CENTER
  const { orgToken } = useParams<{ orgToken: string }>()
  return (
    <Link
      href={`${trustCenterPath(orgToken, TRUST_CENTER_SECTIONS.CONTROLS)}/${domain.slug}`}
      className="flex items-center gap-2.5 rounded border border-trust-center-border px-3.5 py-3 hover:bg-trust-center-subtle"
    >
      <Icon icon={domain.icon} className="size-4 shrink-0 text-trust-center-accent" />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-semibold">{domain.title}</span>
        <span className="text-xs text-trust-center-muted">{CONTROLS.COUNT(domain.items.length)}</span>
      </span>
      <Icon icon="chevron-right" className="size-3.5 shrink-0 text-trust-center-muted" />
    </Link>
  )
}
